import { useEffect } from 'react';
import "./App.css";
import './styles/index.css';
import 'react-toastify/dist/ReactToastify.css';
import ReactDOM from 'react-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { initLogger } from "Logger";
import { StylesProvider } from '@material-ui/core/styles';
import { Route, Router, Switch } from 'react-router-dom';
import { analyticsInitialize, handlePageChange } from 'analytics';
import { LicenseInfo } from '@mui/x-license-pro';
import { createBrowserHistory } from "history";
import InitializeApp from 'layouts/InitializeApp';
import { ToastContainer } from 'react-toastify';
import Hotjar from '@hotjar/browser';
import Unsubscribe from 'pages/Unsubscribe';

/** Environment and configuration constants */
const HOTJAR_ID = Number(process.env.REACT_APP_HOTJAR_ID);
const HOTJAR_VERSION = Number(process.env.REACT_APP_HOTJAR_VERSION);
const IS_PROD = process.env.NODE_ENV === 'production';

// Initialize services
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE as string);
analyticsInitialize();
initLogger();

/** Browser history instance for routing */
const history = createBrowserHistory();

// Configure Sentry
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  maxBreadcrumbs: 10,
  environment: process.env.NODE_ENV,
});

// Track page changes
history.listen(() => {
  handlePageChange();
});

/** Main application component with providers */
const MainApp = () => {
  useEffect(() => {
    if (IS_PROD) {
      Hotjar.init(HOTJAR_ID, HOTJAR_VERSION);
    }
  }, []);

  /** Get the current URL path and search params for redirect */
  const currentPath = window.location.pathname + window.location.search;

  /** Construct redirect URI based on current location */
  const redirectUri = `${window.location.origin}${currentPath}`;

  return (
    <Router history={history}>
      <Switch>
        <Route path="/unsubscribe" component={Unsubscribe} />
        {/* All authenticated routes wrapped in Auth0Provider */}
        <Route path="/">
          <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_DOMAIN as string}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
            audience={process.env.REACT_APP_AUTH0_AUDIENCE as string}
            scope="openid profile"
            redirectUri={window.location.origin}
          >
            <StylesProvider injectFirst>
              <InitializeApp />
              <ToastContainer />
            </StylesProvider>
          </Auth0Provider>
        </Route>
      </Switch>
    </Router>
  );
};

ReactDOM.render(
  <MainApp />,
  document.getElementById('root')
);